/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import draggable from "vuedraggable";

import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue';


import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunitySuggestBtn from '@/components/Community/CommunitySuggestBtn.component.vue';

import TUploadButton from '@/components/Taktify/TUploadButton.component.vue';
import TSearchField from '@/components/Taktify/TSearchField.component.vue';


import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue';
import StatisticsTakt from '@/components/ProjectTaktPlan/StatisticsTakt.component.vue';
import StatisticsBeam from '@/components/ProjectTaktPlan/StatisticsBeam.component.vue';
import StatisticsBeamTaktSum from '@/components/ProjectTaktPlan/StatisticsBeamTaktSum.component.vue';

import WorkBenchWorkPackageTab from '@/components/WorkBench/WorkBenchWorkPackageTab.component.vue';
import Property from '@/components/PropertySets/Property.component.vue';

//waggons
import WorkBenchSequenceWaggon from '@/components/WorkBench/WorkBenchSequenceWaggon.component.vue';
import WorkBenchSequenceWaggonTab from '@/components/WorkBench/WorkBenchSequenceWaggonTab.component.vue';
import WorkBenchSequenceWaggonWorkPackage from '@/components/WorkBench/WorkBenchSequenceWaggonWorkPackage.component.vue';
import WorkBenchSequenceWaggonWorkPackageAdd from '@/components/WorkBench/WorkBenchSequenceWaggonWorkPackageAdd.component.vue';
import SWaggonRecommendation from '@/components/WorkBench/SWaggonRecommendation.component.vue';


import AIIcon from '@/components/WorkBench/AIIcon.component.vue';

export const WorkBenchMaterialMixin = {
  components: {
    draggable,

    StandardDialogFullScreen,
    StandardDialog,
    StandardFlexBox,
    StandardDataField,
    StandardHover,
    StandardBadge,
    StandardOverflowButton,

    StandardDeleteButton,
    StandardDeleteBtn,
    CommunitySuggestBtn,

    TUploadButton,
    TSearchField,

    WorkBenchWorkPackageTab,

    TrainHead,
    TrainTail,
    Waggon,
    Workpackage,
    Activator,
    StatisticsTakt,
    StatisticsBeam,
    StatisticsBeamTaktSum,

    WorkBenchSequenceWaggon,
    WorkBenchSequenceWaggonTab,
    WorkBenchSequenceWaggonWorkPackage,
    WorkBenchSequenceWaggonWorkPackageAdd,
    SWaggonRecommendation,

    Property,

    AIIcon,
  },
  data: () => ({
    update_key_add_hashtag: 0,
    ai_animation_recommendation: false,
    selected_step_type: '',
    selected_more_type: 'costs',
    bottom_bar: {
      show: false,
      content: ''
    },
    focus_page: 'attributes',
    add_step: false,
    edit_step: false,
    edit_id: -1,
    edit_index: -1,
    step_text: "",
    edit_step_templates: false,
    update_key_add_step: 0,
    draggable_steps: false,

    prefix_wp_seletion: ''
  }),
  computed: {
    ...mapGetters('WorkBench', [
      'getWBObject',
      'getWBObjects',
      'getWBObjectsFiltered',
      'getAISequenceWaggons',
      'getSequenceStatistics',
      'getSequenceWorkpackageColors',
      'getSequenceWorkpackageIcons',
      'isWBObjEmpty'
    ]),
    ...mapGetters('WorkBenchLocal', [
      'getWBLObject',
    ]),
    ...mapGetters('Auth', [
      'getUserId',
    ]),
    prefix(){
      switch (this.$route.params.template_type) {
        case 'custom':
          return '';
        case 'company':
          return 'b';
        case 'community':
          return 'c';
        case 'project':
          return 't';
      }
    },
    material(){
      if (this.$route.params.material_id === 'create') {
        let material = this.$store.getters['WorkBenchLocal/getWBLObject']({
          path: [
            {material: ''},
          ]
        });
        material['mfolder'] = parseInt(this.$route.params.mfolder)
        return material
      } else {
        if (this.prefix === 't') {
          return this.$store.getters['Ultra/getUObject']({
            type: `${this.prefix}materials`,
            id: this.$route.params.material_id
          });
        } else {
          return this.$store.getters['WorkBench/getWBObject']({
            type: `${this.prefix}materials`,
            id: this.$route.params.material_id
          });
        }
      }
    },
    workbench_variables() {
      return this.getWBLObject({
        path: [
          {workbench_variables: ''}
        ]
      });
    },
    statistics() {
      return {
        waggon_values: []
      };
      // return this.getSequenceStatistics({
      //   swaggons: this.waggon[`${this.prefix}swaggons`],
      //   local: this.create,
      //   prefix: this.prefix,
      // });
    },
    statistic_settings() {
      return this.getWBLObject({
        path: [
          {waggon_editor_variables: 'statistic_settings'}
        ]
      });
    },
    // waggon() {
    //   if (!this.create) {
    //     return this.edit_waggon;
    //   } else {
    //     return this.new_work_package;
    //   }
    // },
  },
  methods: {
    ...mapActions('WorkBench', [
      'requestWBObject',
      'createWBObject',
      'updateWBObject',
      'updateWBObjectHashtags',
      'deleteWBObject',
      'changeWBObjectPosition',
      'addLoadAll'
    ]),
    ...mapActions('WorkBenchLocal', [
      'createWBLObject',
      'updateWBLObject',
      'deleteWBLObject',
      'resetMaterial'
    ]),
    addHashtag(evt) {
      let hashtags = JSON.parse(JSON.stringify(this.waggon.hashtags));
      hashtags.push({tag: evt.replace(/\s/g,'')});
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}waggons`]: this.waggon_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
      this.update_key_add_hashtag++;
    },
    removeHashtag(index) {
      let hashtags = JSON.parse(JSON.stringify(this.waggon.hashtags));
      hashtags.splice(index, 1);
      this.updateWBObjectHashtags({
        url: [
          {[`${this.prefix}waggons`]: this.waggon_id},
        ],
        update: {
          hashtags: hashtags
        }
      });
    },
    getDraggableStyle(){
      return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
    },
    getUnlikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.splice(likes_copy.findIndex(like => like.user.id === this.getUserId), 1);
      return likes_copy;
    },
    getLikes(likes) {
      let likes_copy = JSON.parse(JSON.stringify(likes));
      likes_copy.push({
        user: {
          id: this.getUserId
        }
      });
      return likes_copy;
    }
  }
};
